import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { FaChevronDown } from 'react-icons/fa'

export default function DropdownMenu({ label = 'Options', items = [] }) {
    return (
        <div className='relative inline-block text-left'>
            <Menu>
                <MenuButton className='inline-flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-1.5 text-sm font-semibold text-gray-500 bg-white hover:bg-gray-100 focus:outline-none'>
                    {label}
                    <FaChevronDown className='w-3 h-3 text-gray-400' />
                </MenuButton>

                <MenuItems
                    transition
                    anchor='bottom end'
                    className='mt-2 origin-top-right bg-white border border-gray-200 rounded-md shadow-md w-44 focus:outline-none transition duration-200 ease-in-out [--anchor-gap:1rem] data-[closed]:-translate-y-1 data-[closed]:opacity-0'
                >
                    {items.map((item, idx) => (
                        <MenuItem key={idx}>
                            {({ active }) => (
                                <button
                                    onClick={item.onClick}
                                    className={`${
                                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                    } flex w-full items-center gap-2 px-4 py-2 text-sm`}
                                >
                                    {item.icon && <span className='shrink-0'>{item.icon}</span>}
                                    {item.label}
                                </button>
                            )}
                        </MenuItem>
                    ))}
                </MenuItems>
            </Menu>
        </div>
    )
}
